import { createSlice, isAnyOf } from "@reduxjs/toolkit";

import { changeNestedArrKeyValueOnCondition } from "core/iterable_utils";

import { deleteVor, fetchVorViewerData, getConnectedLsrItems, getPrintXlsxVor, getXmlVor } from "./";

const initialState = {
	headerData: {},
	tableData: [],
	fetchStatus: null,
	fetchStatusText: null,
	connectedLsrItemModalVisible: false,
	connectedLsrItemModalTableData: [],
};

export const vorSlice = createSlice({
	name: "vor",
	initialState,
	reducers: {
		setHeaderData: (state, { payload }) => {
			state.headerData = payload;
		},
		setTableData: (state, { payload }) => {
			state.tableData = payload;
		},
		setFetchStatus: (state, { payload }) => {
			state.fetchStatus = payload;
		},
		setFetchStatusText: (state, { payload }) => {
			state.fetchStatusText = payload;
		},
		setConnectedLsrItemsModalVisible: (state, { payload }) => {
			state.connectedLsrItemModalVisible = payload;
		},
		setConnectedLsrItemModalTableData: (state, { payload }) => {
			state.connectedLsrItemModalTableData = payload;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(fetchVorViewerData.fulfilled, (state, { payload }) => {
			state.headerData = payload.header_data;
			state.tableData = payload.table_data;
			const scrollKey = localStorage.getItem("scrollKey");
			if (scrollKey) {
				state.tableData = changeNestedArrKeyValueOnCondition({
					arr: state.tableData,
					keySearch: "key",
					valSearch: scrollKey,
					keyChange: "bgColor",
					valChange: "yellow",
					childrenKey: "_children",
				});
				localStorage.removeItem("scrollKey");
				localStorage.removeItem("displayScrollTop");
			}
			state.fetchStatus = "success";
		});

		builder.addCase(getConnectedLsrItems.fulfilled, (state, { payload }) => {
			state.connectedLsrItemModalTableData = payload;
			state.fetchStatus = "success";
		});

		builder.addMatcher(isAnyOf(deleteVor.fulfilled, getXmlVor.fulfilled, getPrintXlsxVor.fulfilled), (state, action) => {
			state.fetchStatus = "success";
		});
		builder.addMatcher(
			isAnyOf(fetchVorViewerData.pending, deleteVor.pending, getXmlVor.pending, getPrintXlsxVor.pending, getConnectedLsrItems.pending),
			(state, action) => {
				state.fetchStatus = "loading";
			}
		);
		builder.addMatcher(
			isAnyOf(fetchVorViewerData.rejected, deleteVor.rejected, getXmlVor.rejected, getPrintXlsxVor.rejected, getConnectedLsrItems.rejected),
			(state, action) => {
				state.fetchStatus = "failed";
				if (action?.payload?.response?.data?.error_text) {
					state.fetchStatusText = action?.payload?.response?.data?.error_text;
				}
			}
		);
	},
});

export const { actions: vorActions, reducer: vorReducer } = vorSlice;
